import { scrollToElement as _scrollToElement } from '@phoenix/helpers/common-helper';

export function scrollToElement(element, behavior = 'smooth', addCheckoutSectionHeaderOffset = true) {
  const navbarElement = document.querySelector('header.header') ?? document.querySelector('div.navigation');

  let offset = navbarElement.getBoundingClientRect().height;

  if (addCheckoutSectionHeaderOffset) {
    offset += document.querySelector('div.checkout-section__header')?.getBoundingClientRect().height ?? 0;
  }

  _scrollToElement(element, behavior, offset);
}
